export default function updateLastPowerJudicialSessionStorage (attributesToChange, clear = false) {
  if (clear) window.sessionStorage.removeItem('last_power_judicial_request')

  const lastPowerJudicial = JSON.parse(sessionStorage.getItem('last_power_judicial_request') || "{}")

  if (attributesToChange) {
    const newLastPowerJudicial = {...lastPowerJudicial, ...attributesToChange}
    sessionStorage.setItem('last_power_judicial_request', JSON.stringify(newLastPowerJudicial))
  }
}